import React from 'react';
export function Footer() {
  return <footer className="w-full border-t border-white/10 bg-ink-900 px-4 pb-28 pt-10 text-center sm:px-6" data-id="element-119" data-mp="32wd2qgad7ltj">
      <p className="font-display text-base text-white" data-id="element-120" data-mp="3ggk7utmc79z0">Anti-Refinement System™</p>
      <p className="mx-auto mt-2 max-w-md text-xs leading-relaxed text-white/45" data-id="element-121" data-mp="32p5qer82vgu2">
        Digital clinical reference for dental professionals working with clear aligners. This
        material is educational and does not replace individual clinical judgment.
      </p>
      <p className="mt-4 text-[11px] text-white/35" data-id="element-122" data-mp="398xsbsbb070">
        © {new Date().getFullYear()} Anti-Refinement System™ · All rights reserved
      </p>
    </footer>;
}